



















































import { Vue, Component, Prop } from 'vue-property-decorator';

import FormLayout from './FormLayout.vue';
import DataList from '../../list/DataList.vue';
import DataItem from '../../list/DataItem.vue';
import PhoneDisplay from '../../PhoneDisplay.vue';

import StepInputTime from '@/components/calendar/StepInputTime.vue';
import StepInputDuration from '@/components/calendar/StepInputDuration.vue';
import BaseBadge from '@/components/badge/BaseBadge.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';

import { formatDateForInput, discardDate, getMinutesDifference } from '@/utils/date';
import { humanizeToRussian } from '@/utils/date/human';

import { ReservedSlot } from '../types';

@Component({
    components: {
        FormLayout,
        DataList,
        DataItem,
        PhoneDisplay,
        StepInputTime,
        StepInputDuration,
        BaseBadge,
        BaseButton,
    },
})
export default class SlotView extends Vue {
    @Prop({ required: true }) event!: ReservedSlot

    get date() {
        return formatDateForInput(this.event.start);
    }

    get startTime() {
        return discardDate(this.event.start);
    }

    get endTime() {
        return discardDate(this.event.end);
    }

    get duration() {
        const duration = getMinutesDifference({
            start: this.event.start,
            end: this.event.end,
        })

        return humanizeToRussian(duration);
    }

    openConsultation() {
        const { id } = this.event.consultation;

        this.$router.push({ name: 'consultation', params: { id }})
    }

    closeConsultationView() {
        this.$emit('close');
    }
}
